import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import * as yup from "yup";

export interface I_InactiveAccountParametersFormMeta {
    applyFeesTo: FormInputMeta;
    ratio: FormInputMeta;
    fix: FormInputMeta;
    min: FormInputMeta;
    max: FormInputMeta;
    case: FormInputMeta;

}

const inactiveAccountParametersFormMeta = {} as I_InactiveAccountParametersFormMeta;

inactiveAccountParametersFormMeta.applyFeesTo = {
    name: "applyFeesTo",
    type: "string",
    label: "Appliquer Frais A(en Mois)",
    placeholder: "",
    validation: yup.string()
};

inactiveAccountParametersFormMeta.ratio = {
    name: "ratio",
    type: "number",
    label: "Taux",
    placeholder: "",
    validation: yup.number()
};

inactiveAccountParametersFormMeta.fix = {
    name: "fix",
    type: "number",
    label: "Fix",
    placeholder: "",
    validation: yup.number()
};

inactiveAccountParametersFormMeta.min = {
    name: "min",
    type: "number",
    label: "Min",
    placeholder: "",
    validation: yup.number()
};

inactiveAccountParametersFormMeta.max = {
    name: "max",
    type: "number",
    label: "Max",
    placeholder: "",
    validation: yup.number()
};

inactiveAccountParametersFormMeta.case = {
    name: "case",
    type: "number",
    label: "Casse (en Mois)",
    placeholder: "",
    validation: yup.number()
};


export default inactiveAccountParametersFormMeta;